import axios from 'axios';
import formatParams from 'jquery-param';

export default {
  fetchBlogEntry({
    commit,
  }, params) {
    return axios.get(`/blogEntry?${formatParams(params)}`)
      .then((res) => {
        const hiddenFields = {
          fields: res.meta.invisibleFields,
          domain: 'blogEntry',
        };

        commit('app/setHiddenFields', hiddenFields, {
          root: true,
        });

        return res;
      });
  },
  saveBlogEntry(_, params) {
    return axios.post('/blogEntry', params);
  },
};
